
import { useCallback } from "react";
import type { Variants } from "framer-motion";

const EASE_OUT: [number, number, number, number] = [0.2, 0.65, 0.3, 1];

export function useMotion() {
  const slideFade = useCallback(
    (dir: "left" | "right" | "up" | "down" = "up", delay = 0, distance = 28): Variants => {
      const x = dir === "left" ? -distance : dir === "right" ? distance : 0;
      const y = dir === "up" ? distance : dir === "down" ? -distance : 0;

      return {
        hidden: { opacity: 0, x, y, filter: "blur(2px)" },
        show: {
          opacity: 1,
          x: 0,
          y: 0,
          filter: "blur(0px)",
          transition: { duration: 0.6, ease: EASE_OUT, delay }
        }
      };
    },
    []
  );

  const containerStagger = useCallback(
    (delay = 0): Variants => ({
      hidden: {},
      show: { transition: { staggerChildren: 0.08, delayChildren: delay } }
    }),
    []
  );

  return { slideFade, containerStagger };
}
